module.exports = __webpack_public_path__ + "static/img/footer_logo.fb06b41.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/footer/footer_logo.png
// module id = CRJi
// module chunks = 11